(() => {
  const nav = document.getElementById('jw-nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const drawer = document.getElementById('jw-nav-drawer');
  const openBtn = document.querySelector('[data-jw-drawer-open]');
  const closeBtn = document.querySelector('[data-jw-drawer-close]');
  if (drawer && openBtn) {
    openBtn.addEventListener('click', () => {
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (drawer && closeBtn) {
    closeBtn.addEventListener('click', () => {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
  if (drawer) {
    drawer.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  document.querySelectorAll('.jw-rv, .rv').forEach((el) => io.observe(el));

  const cio = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        const el = e.target;
        const end = Number(el.dataset.count);
        if (!Number.isFinite(end)) return;
        const dur = 1400;
        const t0 = performance.now();
        const tick = (t) => {
          const p = Math.min((t - t0) / dur, 1);
          const ease = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(end * ease).toLocaleString();
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    },
    { threshold: 0.5 }
  );
  document.querySelectorAll('[data-count]').forEach((el) => cio.observe(el));

  function cartRoot() {
    return (window.Theme?.routes && window.Theme.routes.root) || window.Shopify?.routes?.root || '/';
  }

  function cartAddUrl() {
    return window.Theme?.routes?.cart_add_url || `${cartRoot()}cart/add.js`;
  }

  function updateCartBadge(count) {
    const n = Number(count) || 0;
    document.querySelectorAll('.jw-icon-btn[aria-controls="cart-drawer"], .jw-icon-btn[href*="/cart"]').forEach((btn) => {
      let badge = btn.querySelector('.jw-cart-n');
      if (n > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'jw-cart-n';
          btn.appendChild(badge);
        }
        badge.textContent = String(n);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  async function refreshCartDrawer() {
    const root = cartRoot();
    const res = await fetch(`${root}?sections=cart-drawer-section`);
    if (!res.ok) return;
    const json = await res.json();
    const html = json['cart-drawer-section'];
    if (!html) return;
    const current = document.getElementById('shopify-section-cart-drawer-section');
    if (!current) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const next = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
    if (next) current.replaceWith(next);
  }

  async function openCartDrawer() {
    document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const toggle = document.querySelector('[aria-controls="cart-drawer"]');
    toggle?.click();
  }

  async function addToCart(variantId, quantity = 1) {
    const id = Number(variantId);
    const qty = Number(quantity) || 1;
    if (!id) throw new Error('Missing variant');

    const formData = new FormData();
    formData.append('id', String(id));
    formData.append('quantity', String(qty));
    formData.append('sections', 'cart-drawer-section');

    const res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Add failed');
    }

    if (data.sections && data.sections['cart-drawer-section']) {
      const current = document.getElementById('shopify-section-cart-drawer-section');
      if (current) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data.sections['cart-drawer-section'];
        const next = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
        if (next) current.replaceWith(next);
      }
    } else {
      await refreshCartDrawer();
    }

    try {
      const cartRes = await fetch(`${cartRoot()}cart.js`);
      if (cartRes.ok) {
        const cart = await cartRes.json();
        updateCartBadge(cart.item_count);
      }
    } catch (e) {
      /* ignore badge errors */
    }

    await openCartDrawer();
    return data;
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-jw-add-to-cart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    const original = btn.textContent;
    try {
      await addToCart(variantId, 1);
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1200);
    } catch (err) {
      console.error(err);
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1500);
    }
  });

  /* ---- Collection: filters + view toggle ---- */
  const filterBtn = document.getElementById('filterBtn');
  const filters = document.getElementById('filters');
  if (filterBtn && filters) {
    filterBtn.addEventListener('click', () => {
      filters.classList.toggle('open');
      filterBtn.classList.toggle('on');
    });
  }
  const grid = document.getElementById('grid');
  const v4 = document.getElementById('v4');
  const v2 = document.getElementById('v2');
  if (grid && v4 && v2) {
    v4.addEventListener('click', () => {
      grid.classList.remove('list');
      v4.classList.add('on');
      v2.classList.remove('on');
    });
    v2.addEventListener('click', () => {
      grid.classList.add('list');
      v2.classList.add('on');
      v4.classList.remove('on');
    });
  }
  const sortSel = document.querySelector('[data-jw-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (sortSel.value) url.searchParams.set('sort_by', sortSel.value);
      else url.searchParams.delete('sort_by');
      window.location.href = url.toString();
    });
  }

  /* ---- Contact success (if form posted) ---- */
  const contactForm = document.getElementById('jwForm');
  const sent = document.getElementById('sent');
  const formBody = document.getElementById('formBody');
  if (contactForm && sent && formBody) {
    if (window.location.search.includes('contact_posted=true') || document.querySelector('.form-success-flag')) {
      formBody.style.display = 'none';
      sent.classList.add('show');
    }
  }

  /* ---- PDP ---- */
  const pdp = document.querySelector('[data-jw-pdp]');
  if (pdp) {
    const qtyInput = document.getElementById('qty');
    const minus = document.getElementById('minus');
    const plus = document.getElementById('plus');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      plus.addEventListener('click', () => {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    const mainImg = document.getElementById('stageMedia');
    const stickyThumbImg = document.getElementById('stickyThumbImg');
    document.querySelectorAll('[data-jw-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('[data-jw-thumb]').forEach((t) => t.classList.remove('on'));
        thumb.classList.add('on');
        const src = thumb.getAttribute('data-full-src');
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.srcset = '';
        }
      });
    });

    const sticky = document.getElementById('sticky');
    const buyCol = document.querySelector('.buy');
    if (sticky && buyCol) {
      const onScrollSticky = () => {
        const rect = buyCol.getBoundingClientRect();
        sticky.classList.toggle('up', rect.bottom < 0);
      };
      window.addEventListener('scroll', onScrollSticky, { passive: true });
      onScrollSticky();
    }

    const variantJson =
      pdp.querySelector('[data-jw-variants]') || document.querySelector('[data-jw-variants]');
    let variants = [];
    try {
      variants = variantJson ? JSON.parse(variantJson.textContent) : [];
    } catch (e) {
      variants = [];
    }
    const optionSelects = {};
    pdp.querySelectorAll('[data-option-index]').forEach((group) => {
      const idx = group.getAttribute('data-option-index');
      optionSelects[idx] = group.querySelector('.sw.on, .dot.on')?.getAttribute('data-value') || '';
      group.querySelectorAll('.sw, .dot').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('off')) return;
          group.querySelectorAll('.sw, .dot').forEach((b) => b.classList.remove('on'));
          btn.classList.add('on');
          optionSelects[idx] = btn.getAttribute('data-value');
          const label = group.querySelector('.opt-label .v');
          if (label) label.textContent = optionSelects[idx];
          updateVariant();
        });
      });
    });

    function currentOptions() {
      return [1, 2, 3].map((i) => optionSelects[String(i - 1)] || null);
    }

    function findVariant() {
      const opts = currentOptions().filter((v) => v != null && v !== '');
      if (!opts.length) return variants[0];
      return variants.find((v) => {
        const vals = v.options || [];
        return opts.every((o, i) => !o || vals[i] === o);
      });
    }

    function money(cents) {
      try {
        return Shopify.formatMoney
          ? Shopify.formatMoney(cents)
          : `$${(cents / 100).toFixed(2)}`;
      } catch (e) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }

    function updateVariant() {
      const v = findVariant();
      if (!v) return;
      pdp.querySelectorAll('[data-variant-id]').forEach((el) => el.setAttribute('data-variant-id', v.id));
      const priceEls = pdp.querySelectorAll('[data-jw-price]');
      priceEls.forEach((el) => {
        el.textContent = money(v.price);
      });
      const atc = document.getElementById('atc');
      if (atc) {
        atc.disabled = false;
        const managed = v.inventory_management != null && v.inventory_management !== '';
        const isMto = (managed && Number(v.inventory_quantity) <= 0) || v.available === false;
        const label = isMto
          ? `Pre-order — ${money(v.price)} `
          : `Add to cart — ${money(v.price)} `;
        atc.textContent = label;
        const arr = document.createElement('span');
        arr.className = 'arr';
        arr.textContent = '→';
        atc.appendChild(arr);
      }
      const stock = document.querySelector('.stockline');
      if (stock) {
        const managed = v.inventory_management != null && v.inventory_management !== '';
        const isMto = (managed && Number(v.inventory_quantity) <= 0) || v.available === false;
        const text = isMto
          ? 'Made to order — ships in 3–7 days'
          : 'In stock — ships in 1–2 days';
        stock.innerHTML = '<i></i> ' + text;
      }
      if (v.featured_image) {
        if (mainImg) {
          mainImg.src = v.featured_image;
          mainImg.srcset = '';
        }
        if (stickyThumbImg) {
          stickyThumbImg.src = v.featured_image;
          stickyThumbImg.srcset = '';
        }
        const thumbs = document.querySelectorAll('[data-jw-thumb]');
        const matchId = v.featured_image_id != null ? String(v.featured_image_id) : '';
        thumbs.forEach((t) => {
          t.classList.toggle('on', matchId !== '' && t.getAttribute('data-media-id') === matchId);
        });
      }
    }

    const atc = document.getElementById('atc');
    if (atc) {
      atc.addEventListener('click', async () => {
        const v = findVariant() || variants[0];
        const variantId = v?.id || atc.getAttribute('data-variant-id');
        if (!variantId) return;
        const qty = parseInt(qtyInput?.value || '1', 10) || 1;
        atc.disabled = true;
        try {
          await addToCart(variantId, qty);
          atc.textContent = 'Added ✓';
          setTimeout(updateVariant, 1200);
        } catch (e) {
          console.error(e);
          atc.textContent = 'Error';
          setTimeout(updateVariant, 1500);
        } finally {
          atc.disabled = false;
        }
      });
    }

    const buyNow = document.getElementById('buyNow');
    if (buyNow) {
      buyNow.addEventListener('click', async () => {
        const v = findVariant() || variants[0];
        const variantId = v?.id || atc?.getAttribute('data-variant-id');
        if (!variantId) return;
        const qty = parseInt(qtyInput?.value || '1', 10) || 1;
        try {
          await addToCart(variantId, qty);
          window.location.href = `${cartRoot()}checkout`;
        } catch (e) {
          console.error(e);
        }
      });
    }

    const stickyAtc = document.getElementById('stickyAtc');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', () => atc?.click());
    }

    updateVariant();
  }
})();
